module.exports = __webpack_public_path__ + "assets/img/qrcode.43397cc4.png";